import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please complete this required field.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please complete this required field.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please complete this required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please complete this required field.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    accountExtra2: {
      validations: [
        { type: 'required', message: 'Please complete this required field.' }
      ]
    },
    accountExtra3: {
      validations: []
    },
    accountExtra4: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    reference: {
      validations: [
        { type: 'required', message: 'Please select an option from the dropdown menu.' }
      ]
    },
    accountextra1: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name*',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Your Email*',
            mapping: 'email'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone*',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Event Location*',
            mapping: 'accountExtra2'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Type of Event*',
            mapping: 'accountExtra3'
          },
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Date of Event',
            mapping: 'accountExtra4'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How did you hear about us?*',
            options: [
              { label: 'Internet Search'  , value: 'Internet Search'},
              { label: 'Advertisement'  , value: 'Advertisement'},
              { label: 'A friend or Relative'  , value: 'A friend or Relative'},
              { label: 'Venue Referral'  , value: 'Venue Referral'},
              { label: 'Facebook/Instagram/Pinterest'  , value: 'Facebook/Instagram/Pinterest'},
              { label: 'Weddingwire'  , value: 'Weddingwire'},
              { label: 'The Knot'  , value: 'The Knot'},
              { label: 'Other'  , value: 'Other'}
            ],
            mapping: 'reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'XLarge',
            label: 'Message',
            mapping: 'notes',
          }
        ]
      },
      {
        fields: [
          {
            type: 'checkbox-list',
            size: 'XLarge',
            options: [
              { label: 'Subscribe to our quarterly newsletter'  , value: 'Yes-Subscribe'},
            ],
            mapping: 'accountextra1',
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Peppers Artful Events Contact Form',
    formId: '374',
    clientKey: 'EE16A913-30FE-45A5-A9BF-89B19FD7337F',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'https://www.peppersartfulevents.com/thank-you',
    submissionText: 'Thank you for your interest in Peppers. One of our Event Designers will be in contact with you shortly!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/peppersartful/form_structure.js